import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { updateTombaEmailApiSettings } from '../../../redux/actions/apiSettings';
import Loader from '../../Loader';

const Tomba = ({ loading, emailApis }) => {
	const dispatch = useDispatch();
  const [disabledBtnConfirm, setDisabledBtnConfirm] = useState(false);

	const [tombaForm, setTombaForm] = useState({
		apiKey: '',
		secretKey: '',
		approveForWebmail: false,
		type: 'tomba',
	});

	useEffect(() => {
		if (emailApis?.hunter) {
			emailApis.tomba.type = 'tomba';
			setTombaForm(emailApis.tomba);
		}
	}, [emailApis]);

  useEffect(()=> {
    if ((tombaForm?.apiKey?.length === 0) || (tombaForm?.secretKey?.length === 0) ) {
      setDisabledBtnConfirm(true);
      // console.log("The btn true vlaue:::===>>>", disabledBtnConfirm)
    } else {
      setDisabledBtnConfirm(false);
      // console.log("The btn false vlaue:::===>>>", disabledBtnConfirm)
    } 
  },[tombaForm])

	const handleTombaFormSubmit = (e) => {
		e.preventDefault();
		if (tombaForm.apiKey.trim() && tombaForm.secretKey.trim()) {
			dispatch(updateTombaEmailApiSettings(tombaForm));
		} else {
			toast.error('Please fill field for api key and secret key');
		}
	};

	return (
		<>
			{loading && <Loader />}

			<div id='tab-2' className='tab-content current'>
				<div className='hunterTabContent'>
        <div className="contentInputWrapers">
					<p className='tabHeadingP'>Add Tomba API Key & Secret Key</p>
          
          <input
							type='text'
							className='inputBox'
							placeholder='Enter your API key'
							value={tombaForm.apiKey}
							onChange={(e) =>
								setTombaForm({ ...tombaForm, apiKey: e.target.value })
							}
						/>
						<input
							type='text'
							className='inputBox'
							placeholder='Enter Tomba secret key'
							value={tombaForm.secretKey}
							onChange={(e) =>
								setTombaForm({ ...tombaForm, secretKey: e.target.value })
							}
						/>
            </div>
            {console.log("The value is at this". tombaForm)}
					<div className='fieldWrapers tabsSec'>
						
						<span className='optionButton'>
							<span className='btntext'>Approve for webmail</span>
							<label className='switch'>
								<input
									type='checkbox'
									defaultChecked={tombaForm.approveForWebmail}
									className={tombaForm.approveForWebmail ? 'checked' : ''}
									onChange={(e) =>
										setTombaForm({
											...tombaForm,
											approveForWebmail: !tombaForm.approveForWebmail,
										})
									}
								/>
								<span className='slider round'></span>
							</label>{' '}
						</span>
						<button className='apiBtn' disabled={disabledBtnConfirm} onClick={handleTombaFormSubmit}>
							Confirm
						</button>
					</div>
				</div>
			</div>
		</>
	);
};

export default Tomba;
